export default "/images/slide1.jpg?3512328f4215f72e815c6dca35fc981d";